const funcs = []

function add (path, func) {
	funcs.push([path, func])
}

function dispatch () {
	const pathname = location.pathname
	for(let i = 0, ii = funcs.length; i < ii; ++i) {
		let matched = pathname.match(funcs[i][0])
		if (matched) {
			funcs[i][1](matched)
		}
	}
}

export default {add, dispatch}